import { Box, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  textContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 40,
    marginTop: '10px',
    backgroundColor: '#f0f0f0'

  },
  line1: {
    position: 'absolute',
    top: 0,
    whiteSpace: 'nowrap',
    animation: '$moveText 10s linear infinite',
    right: '10%',
    animationDelay: '0s',
  },
  '@keyframes moveText': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(-200%)',
    },
  },
}));

const GovtStrip = () => {
  const classes = useStyles()
  return (
    <Box sx={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#f0f0f0', padding: '0 1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="image1" style={{ height: '70px', marginRight: '20px' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight="bold" sx={{ marginTop: '10px', fontSize: '20px', width: '450px' }} className='titlegov'>Urban Development Department</Typography>
          <Typography variant="h6" sx={{ marginTop: '12px', fontSize: '15px', fontStyle: "italic", width: '450px' }}>Govt of Uttar Pradesh, India</Typography>
        </Box>
      </div>
      <div>
        {/* <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="image2" style={{ height: '70px', marginLeft: '30px', marginRight: '30px', display: 'inline' }} /> */}
        <img src="https://i.imgur.com/TmeY0xa.jpeg" alt="image3" style={{ height: '70px', marginLeft: '30px', marginRight: '30px', display: 'inline' }} />
        <img src="https://i.imgur.com/ERyQTFC.png" alt="image4" style={{ height: '70px', marginLeft: '30px', marginRight: '30px', display: 'inline' }} />
        <img src='https://www.hsvphry.org.in/assets/img/150-years-Mahatma-Gandhi-Logo.png' alt='image5' style={{ height: '70px', marginLeft: '30px', marginRight: '0px', display: 'inline' }} />
      </div>
    </Box>
  );
};

export default GovtStrip;
